import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from '../hooks/use-i18n'

const Solutions: React.FC = () => {
  const { t } = useTranslation()
  const solutions = [
    {
      title: t('landing.solutions.item1.title'),
      problem: t('landing.solutions.item1.problem'),
      solution: t('landing.solutions.item1.solution'),
      icon: '🚀',
    },
    {
      title: t('landing.solutions.item2.title'),
      problem: t('landing.solutions.item2.problem'),
      solution: t('landing.solutions.item2.solution'),
      icon: '📊',
    },
    {
      title: t('landing.solutions.item3.title'),
      problem: t('landing.solutions.item3.problem'),
      solution: t('landing.solutions.item3.solution'),
      icon: '🌿',
    },
    {
      title: t('landing.solutions.item4.title'),
      problem: t('landing.solutions.item4.problem'),
      solution: t('landing.solutions.item4.solution'),
      icon: '🌍',
    },
  ]

  return (
    <div className="min-h-screen">
      <section className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-12 sm:py-16 lg:py-24">
        <div className="text-center mb-12 sm:mb-16">
          <h1 className="text-2xl sm:text-3xl lg:text-5xl xl:text-6xl font-bold mb-4 sm:mb-6 text-white leading-tight">
            {t('landing.solutions.title').replace(t('landing.solutions.titleHighlight'), '')}<span className="bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">{t('landing.solutions.titleHighlight')}</span>
          </h1>
          <p className="text-lg sm:text-xl lg:text-2xl text-white/80 max-w-3xl mx-auto mb-8">
            {t('landing.solutions.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/signup"
              className="inline-flex justify-center px-8 py-4 rounded-full bg-black hover:bg-black/80 text-white font-semibold transition-all duration-300"
            >
              {t('common.startForFree')}
            </Link>
            <Link
              to="/product"
              className="inline-flex justify-center px-8 py-4 rounded-full border border-white/20 text-white font-medium hover:bg-white/5 transition-all duration-300"
            >
              {t('common.seeProduct')}
            </Link>
          </div>
        </div>

        <div className="space-y-6 sm:space-y-8 mb-16">
          {solutions.map((s, i) => (
            <div
              key={i}
              className="bg-[#1a1a1a] border border-white/10 rounded-2xl p-6 sm:p-8 flex flex-col sm:flex-row gap-6 items-start hover:border-white/20 transition-all duration-300"
            >
              <div className="text-4xl sm:text-5xl flex-shrink-0">{s.icon}</div>
              <div>
                <h2 className="text-xl sm:text-2xl font-bold text-white mb-2">{s.title}</h2>
                <p className="text-white/70 font-medium mb-2">{s.problem}</p>
                <p className="text-white/80 leading-relaxed">{s.solution}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center bg-[#1a1a1a] rounded-2xl p-8 sm:p-12 border border-white/10">
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">{t('landing.solutions.cta.title')}</h3>
          <p className="text-white/70 mb-6 max-w-xl mx-auto">
            {t('landing.solutions.cta.body')}
          </p>
          <Link
            to="/signup"
            className="inline-flex justify-center px-8 py-4 rounded-full bg-black hover:bg-black/80 text-white font-semibold transition-all duration-300"
          >
            {t('common.startForFree')}
          </Link>
        </div>
      </section>
    </div>
  )
}

export default Solutions
